import React from 'react';
import cn from 'classnames';
import LazyImage from 'components/UI/LazyImage';

import * as styles from './OwnerInfo.module.scss';

export default function OwnerInfo({ photo, position, name, className }) {
  return photo ? (
    <figure className={cn(styles.figure, className)}>
      <LazyImage className={styles.figureImage} src={photo} alt={position} />
      <figcaption className={styles.figcaption}>
        <p className={styles.name}>{name}</p>
        <p className={styles.position}>{position}</p>
      </figcaption>
    </figure>
  ) : (
    <div className={cn(styles.figcaption, className)}>
      <p className={styles.name}>{name}</p>
      <p className={styles.position}>{position}</p>
    </div>
  );
}
